import Material from './Country';

interface CompanyLocation {
    id: number;
    address: string;
    city: string;
    countryId: number;
    phoneOffice: string;
    phoneMobile: string | null;
    email: string;
    employee: number | null;
    country: Material;
}

const EmptyCompanyLocation: CompanyLocation = {
    id: 0,
    address: '',
    city: '',
    countryId: 0,
    phoneOffice: '',
    phoneMobile: null,
    email: '',
    employee: null,
    country: {
        id: 0,
        name: ''
    }
};

export { EmptyCompanyLocation };

export default CompanyLocation;
